import Reflux from 'reflux';
import { BundleActions, AppActions } from 'actions';
import SteelCompass from 'services/SteelCompass';
import { history } from 'helpers';

var BundleStore = Reflux.createStore({
  listenables: [BundleActions],
  data: {
    list: [],
    loading: false,
    saving: false,
    selected: null
  },

  getInitialState() {
    return this.data;
  },

  onRead(includeRead, callback) {
    this.data.loading = true;
    this.trigger(this.data);
    return SteelCompass.call('course-package', 'read', {}, response => {
      BundleActions.readComplete(response.data);
      if (callback) {
        callback();
      }
    });
  },

  onReadComplete(data) {
    this.data = {
      list: data,
      loading: false,
      saving: false,
      selected: null
    };
    this.trigger(this.data);
  },

  findById(id) {
    this.data.loading = true;
    this.trigger(this.data);
    return SteelCompass.call('course-package', 'findById', { id }, response => {
      if (response.isError) {
        AppActions.genericError(response.errMsg);
      } else {
        BundleActions.findByIdComplete(response.data);
      }
    });
  },

  findByIdComplete(bundle) {
    this.data.loading = false;
    this.data.selected = bundle;
    this.trigger(this.data);
  },

  onFindByIdError(errorMessage) {
    this.data.loading = false;
    this.data.errorMessage = errorMessage;
    this.trigger(this.data);
  },

  onUpdate(bundleId, bundle) {
    this.data = {
      ...this.data,
      saving: true
    };
    this.trigger(this.data);
    bundle.id = bundleId;
    return SteelCompass.call('course-package', 'update', bundle, response => {
      if (response.isError) {
        AppActions.genericError(response.errMsg);
      } else {
        BundleActions.updateComplete(response.data);
      }
    });
  },

  onUpdateComplete(bundle) {
    this.data = {
      ...this.data,
      selected: {
        ...this.data.selected,
        ...bundle
      }
    };
    this.trigger(this.data);
  },

  onCreate(bundle) {
    this.data.saving = true;
    this.trigger(this.data);
    return SteelCompass.call('course-package', 'create', bundle, response => {
      if (response.isError) {
        AppActions.genericError(response.errMsg);
      } else {
        BundleActions.createComplete(response.data);
        BundleActions.read();
      }
    });
  },
  createComplete(bundle) {
    history.push(`/bundle/${bundle.id}`);
  },
  onRemoveComplete(bundle) {
    let found = -1,
      bundles = this.data.list;
    for (let i = 0; i <= bundles.length; i++) {
      if (bundles[i].id === bundle.id) {
        found = i;
        break;
      }
    }
    if (found >= 0) {
      bundles.splice(found, 1);
      this.data.list = bundles;
      this.trigger(this.data);
    }
    history.push('/bundles');
  },
  onRemove(bundle) {
    return SteelCompass.call(
      'course-package',
      'delete',
      { id: bundle.id },
      response => {
        if (response.isError) {
          BundleActions.removeError(response.errMsg);
        } else {
          BundleActions.removeComplete(bundle);
        }
      }
    );
  },
  addTag(bundleId, name) {
    return SteelCompass.request('tag', 'addLink', {
      objectId: bundleId,
      objectType: 3,
      name
    }).then(
      response => {
        BundleActions.addTagComplete(bundleId, name);
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },
  removeTag(bundleId, name) {
    return SteelCompass.request('tag', 'removeLink', {
      objectId: bundleId,
      objectType: 3,
      name
    }).then(
      response => {
        BundleActions.removeTagComplete(bundleId, name);
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },
  addTagComplete(bundleId, name) {
    this.data = {
      ...this.data,
      list: this.data.list.map(bundle => {
        if (bundle.id === bundleId) {
          const tagsMap = bundle.tagsMap || {};
          return {
            ...bundle,
            tagsMap: {
              ...tagsMap,
              [name]: true
            }
          };
        }
        return bundle;
      })
    };
    if (this.data.selected.id === bundleId) {
      const tagsMap = this.data.selected.tagsMap || {};
      this.data = {
        ...this.data,
        selected: {
          ...this.data.selected,
          tagsMap: {
            ...tagsMap,
            [name]: true
          }
        }
      };
    }
    this.trigger(this.data);
  },
  removeTagComplete(bundleId, name) {
    this.data = {
      ...this.data,
      list: this.data.list.map(bundle => {
        if (bundle.id === bundleId) {
          const tagsMap = bundle.tagsMap || {};
          return {
            ...bundle,
            tagsMap: {
              ...tagsMap,
              [name]: false
            }
          };
        }
        return bundle;
      })
    };
    if (this.data.selected.id === bundleId) {
      const tagsMap = this.data.selected.tagsMap || {};
      this.data = {
        ...this.data,
        selected: {
          ...this.data.selected,
          tagsMap: {
            ...tagsMap,
            [name]: false
          }
        }
      };
    }
    this.trigger(this.data);
  }
});

export default BundleStore;



// WEBPACK FOOTER //
// ./src/js/stores/Bundle.js